export default {
  title: 'Belarus, Ukraine',
  presenter: 'by_ua',
  text: `
# Embassy of Ukrajiny

# Embassy of Belarus - Bratislava
## Denis Sidorov - Counsellor of the Embassy of Belarus

# Success story
## PROGAST - Juricová Ingrid (Belarus)
  `,
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/data/presentations/by_ua.js